import { cmsModule } from '@utils';

export default [...cmsModule('heading')];
